
import wxBridge from '../jsbridge/jsbridge_base.js';
import env from '../common/env.js';

wxBridge.openGameTabHome = wxBridge.openGameTabHome  || function(param, callback) {
    if( !window.wgclient?.__gameTabHeight__ ) { // 非原生tab场景
        wxBridge.invoke('openGameTabHome', param, callback);
        return
    }
    if( env.isAndroid ) {
        wxBridge.invoke('switchToGameTab', param, callback);
    }else {
        let identifier = 'switchToGameTab-' + Date.now();
        wxBridge.invoke('gameCenterFacade', {
            'gamecenter_methodname': 'switchToGameTab',
            'gamecenter_identifier': identifier,
            'gamecenter_params': param,
        }, (res) => {
            if (!res || res.gamecenter_identifier !== identifier) {
                return;
            }
            callback(res);
        });
    }
};

export default wxBridge;

export const {
    openGameTabHome
} = wxBridge;
